<ng-template class="light-dropdown" #al let-r="result" let-t="term">
  <span>{{ formatLocationAddress | memoize: r }}</span>
  @if (r.isLoading) {
    <i class="button_spinner input_loading_spinner light-spinner"></i>
  }
</ng-template>
<ng-template #airlinesTemplate let-r="result" let-t="term">
  {{ r.name }}
</ng-template>
<ng-template #sl let-r="result" let-t="term">
  <div class="typeahead-result">
    <i
      class="ico-{{
        r.type === LocationTypes.Airport
          ? 'flight'
          : r.type === LocationTypes.TrainStation
            ? 'rail'
            : r.type === LocationTypes.Hotel
              ? 'bed'
              : 'marker'
      }}"
    ></i>
    <span
      >&nbsp;
      @switch (r.type) {
        @case (LocationTypes.Airport) {
          {{ r.name }}
          @if (r.iata) {
            ({{ r.iata }})
          }
        }
        @case (LocationTypes.TrainStation) {
          {{ r.name }}
        }
        @default {
          {{ formatLocationAddress | memoize: r }}
        }
      }
    </span>
  </div>
</ng-template>
<mat-expansion-panel
  class="location-panel"
  [disabled]="required || isVia"
  [expanded]="required || isVia"
>
  @if (!isVia) {
    <mat-expansion-panel-header>
      <mat-panel-title
        >{{ title }}&nbsp;
        @if (required) {
          <span class="light-color-warning">*</span>
        }
      </mat-panel-title>
    </mat-expansion-panel-header>
  }
  <fieldset>
    <legend class="visuallyhidden">{{ title }}</legend>
    <mat-radio-group [(ngModel)]="mode" class="radio-buttons-container">
      <mat-radio-button class="light-primary" color="primary" [value]="TaxiFormMode.ADDRESS">
        <span [attr.aria-label]="title + ' Address'" i18n="@@taxiAddressAddress">Address</span>
      </mat-radio-button>
      <div class="radio-button-wrapper flex-row-container align-items-end">
        <mat-radio-button class="light-primary" color="primary" [value]="TaxiFormMode.SAVEDADDRESS">
          <span [attr.aria-label]="title + ' Train St. / Airport'" i18n="@@taxiSavedAddress"
            >Saved address</span
          >
        </mat-radio-button>
      </div>
    </mat-radio-group>
    <div class="flex-row-container flex-row-container--wrap">
      <div class="location-block">
        @if (mode === TaxiFormMode.ADDRESS) {
          <label
            class="header-label"
            for="{{ title }}address"
            id="{{ transformedTitle }}-taxi-address-choose-address"
            >{{ title }}</label
          >
          <div class="flex-row-container">
            <i class="ico-marker select-box-icon"></i>
            <input
              class="location-search"
              #inputStation="ngbTypeahead"
              [inputFormatter]="formatAddresses"
              [(ngModel)]="address"
              [resultTemplate]="sl"
              [ngbTypeahead]="getGeoLocations"
              autocomplete="off"
              type="text"
              id="{{ title }}address"
              i18n-placeholder
              placeholder="Please enter an address, airport, train station, landmark or hotel"
              name="travellingFrom"
              container="body"
              placement="bottom-left"
              (selectItem)="setLocation($event.item)"
              appInput
              [noIcon]="false"
              class="button-box"
              attr.aria-labelledby="{{ transformedTitle }}-taxi-address-choose-address"
              [editable]="false"
              [required]="mode === TaxiFormMode.ADDRESS"
              (input)="onInputClear($event.target.value)"
              (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
              (keyup.arrowup)="ensureElementIsScrolledTo($event)"
            />

            <button
              id="{{ transformedTitle }}-taxi-save-address-button"
              (click)="saveAddress()"
              [disabled]="!validAddress() || savingAddress"
              class="save-address-icon"
            >
              @if (savingAddress) {
                <app-loading-spinner size="sm" />
              }
              @if (!savingAddress) {
                <i class="ico-add"></i>
              }
              <span class="visuallyhidden">{{ title }}</span>
              <span class="visuallyhidden" i18n="@@taxiAddressForm">Form</span>
            </button>
            @if (loadingStations | async) {
              <i class="button_spinner input_loading_spinner_no_button light-spinner"></i>
            }
          </div>
          @if (showManualStreetFields) {
            <div
              class="street-missing-prompt"
              [ngClass]="{
                'error-box': searchParams.validationMessages?.includes(
                  validationType + ' - Enter house number/name and street'
                )
              }"
            >
              <label
                id="{{ transformedTitle }}-taxi-address-house-no"
                class="header-label"
                i18n="@@taxiAddressNoName"
                for="{{ title }}taxihome"
                >{{ title }} House N°/Name*:</label
              >
              <input
                attr.aria-labelledby="{{ transformedTitle }}-taxi-address-house-no"
                appInput
                [noIcon]="true"
                #inputHouse
                required
                i18n-placeholder
                placeholder="Enter number or house name"
                id="{{ title }}taxihome"
                [ngModel]="address.House"
                (ngModelChange)="onHouseInputChange($event)"
              />
              <label
                id="{{ transformedTitle }}-taxi-address-street"
                class="header-label"
                for="{{ title }}taxistreet"
                i18n="@@taxiAddressStreetRequired"
                >{{ title }} Street*:</label
              >
              <input
                attr.aria-labelledby="{{ transformedTitle }}-taxi-address-street"
                appInput
                [noIcon]="true"
                #inputStreet
                required
                i18n-placeholder
                id="{{ title }}taxistreet"
                placeholder="Enter street"
                [ngModel]="address.Street"
                (ngModelChange)="onStreetInputChange($event)"
              />
              @if (streetMissing) {
                <div class="error-message mt-2" i18n="@@taxiEnterHouseAndStreet">
                  Please enter the house number/name and street for this location.
                </div>
              }
            </div>
          }
        } @else {
          <label
            id="{{ transformedTitle }}-taxi-address-pick-from-saved"
            class="header-label"
            for="{{ title }}address"
            i18n="@@taxiAddressPickFromSaved"
            >Pick from saved ({{ title }}):</label
          >
          <div class="flex-row-container savedAddressDiv">
            @if (loadingAddresses | async) {
              <i
                class="button_spinner input_loading_spinner_no_button light-spinner savedAddressButton"
              ></i>
            }
            <input
              readonly
              #inputAddress="ngbTypeahead"
              [inputFormatter]="formatAddresses"
              [ngbTypeahead]="getAddresses"
              autocomplete="off"
              type="text"
              id="{{ title }}address"
              i18n-placeholder
              placeholder="Select saved address"
              [resultTemplate]="al"
              (click)="$event.target.select()"
              name="travellingFrom"
              [(ngModel)]="address"
              (selectItem)="selectedAddress($event)"
              (focus)="updateAddress($event)"
              (click)="updateAddress($event)"
              [resultFormatter]="resultFormatBandListValue"
              appSelect
              [noIcon]="true"
              class="savedAddressInput"
              attr.aria-labelledby="{{ transformedTitle }}-taxi-address-pick-from-saved"
              container="body"
              placement="bottom-left"
              (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
              (keyup.arrowup)="ensureElementIsScrolledTo($event)"
            />
          </div>
        }
      </div>
      @if (showDateBlock) {
        <div class="date-block flex-row-container flex-row-container--wrap">
          <div
            class="flex-row-container"
            [ngClass]="{
              'error-box': searchParams.validationMessages?.includes(
                'Taxi journey cannot be in the past.'
              )
            }"
          >
            <ngbd-datepicker-i18n>
              <div class="flex-column-container combo-box-left">
                <label
                  class="header-label date-label"
                  for="search-taxi-pickup-date"
                  i18n="@@taxiSearchPickupDate"
                  >Pick-up date (DD/MM/YYYY)</label
                >
                <i
                  class="ico-calendar combo-box-icon"
                  aria-hidden="true"
                  style="cursor: pointer"
                ></i>
                <app-datepicker
                  [minDate]="today"
                  [startDate]="searchParams.date"
                  [model]="searchParams.date"
                  [class]="'combo-box'"
                  [componentId]="'search-taxi-pickup-date'"
                  (newDate)="searchParams.date = $event"
                >
                </app-datepicker>
              </div>
              <div class="flex-column-container select-box-right">
                <label
                  id="search-taxi-pickup-time"
                  class="header-label"
                  i18n="@@TaxiSearchPickupTime"
                  for="taxi_pickup-time"
                  >Pick-up time</label
                >
                <i class="ico-clock combo-box-icon" aria-hidden="true"></i>
                <select appSelect id="taxi_pickup-time" [(ngModel)]="searchParams.time">
                  @for (time of timesArray; track time) {
                    <option [ngValue]="time">{{ time }}</option>
                  }
                </select>
              </div>
            </ngbd-datepicker-i18n>
          </div>
          <div class="flex-column-container transport-container">
            <div class="flex-row-container flex-row-container--wrap flex-row-container--v-center">
              <label
                id="taxi-search-transport-type"
                class="header-label"
                for="taxi_type"
                i18n="@@taxiSearchTransportType"
              >
                Transport type
              </label>
              @if (hasGroundspan) {
                <section (mouseleave)="tt.close()">
                  <button
                    type="button"
                    class="accessible-tooltip-trigger ico ico-info-circle"
                    ngbTooltip="If you require a Chauffer Driven car please select Chauffeur car as your transport type."
                    aria-label="If you require a Chauffer Driven car please select Chauffeur car as your transport type."
                    i18n-ngbTooltip
                    i18n-aria-label
                    placement="bottom"
                    container="body"
                    triggers="manual"
                    #tt="ngbTooltip"
                    (mouseenter)="tt.open()"
                    (focus)="tt.open()"
                    (blur)="tt.close()"
                    (click)="tt.toggle()"
                  ></button>
                </section>
              }
            </div>
            <select
              appSelect
              [noIcon]="true"
              [(ngModel)]="searchParams.vehicleType"
              aria-labelledby="taxi-search-transport-type"
              id="taxi_type"
            >
              @for (transType of transTypes; track transType; let i = $index) {
                <option [ngValue]="transType.key">
                  <span id="transport-type-{{ i }}">{{ transType.value | translate }}</span>
                </option>
              }
            </select>
          </div>
        </div>
        @if (searchParams.vehicleType === CabHireVehicleType.Limo) {
          <div class="limo--wrapper">
            <div class="flex-column-container">
              <label class="header-label" i18n="@@limoSearchOptions" id="limo-search-options"
                >Select search options</label
              >
              <div class="flex-row-container">
                <mat-radio-group
                  [(ngModel)]="searchParams.transportType"
                  class="radio-buttons-container"
                  aria-labelledby="limo-search-options"
                >
                  <mat-radio-button
                    class="light-primary"
                    color="primary"
                    [value]="TransportType.OneWay"
                    i18n="@@LimoOneWay"
                    >One way
                  </mat-radio-button>
                  <mat-radio-button
                    class="light-primary"
                    color="primary"
                    [value]="TransportType.Hourly"
                    i18n="@@LimoBythehour"
                    >By The Hour
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div class="limo--options-container">
              <div class="limo--type-container">
                <label
                  id="limo-search-type"
                  class="header-label"
                  for="limo_type"
                  i18n="@@taxiSearchVehicleType"
                  >Vehicle type:</label
                >
                <select
                  appSelect
                  [noIcon]="true"
                  aria-labelledby="limo-search-type"
                  [(ngModel)]="searchParams.limoType"
                  id="limo_type"
                >
                  @for (limoType of searchParams.limoTypes; track limoType; let i = $index) {
                    <option [ngValue]="limoType.key">
                      <span id="lime-type-{{ i }}">{{ limoType.value }}</span>
                    </option>
                  }
                </select>
              </div>
              @if (searchParams.transportType === TransportType.Hourly) {
                <div class="limo--duration-container">
                  <label
                    id="limo-search-duration"
                    class="header-label"
                    for="limo_duration"
                    i18n="@@taxiSearchDuration"
                    >Duration:</label
                  >
                  <select
                    appSelect
                    [noIcon]="true"
                    aria-labelledby="limo-search-duration"
                    [(ngModel)]="searchParams.limoAsDirectedDuration"
                    id="limo_duration"
                  >
                    @for (
                      limoAsDirectedDuration of limoDurations;
                      track limoAsDirectedDuration;
                      let i = $index
                    ) {
                      <option [value]="limoAsDirectedDuration">
                        <span id="limo-durations-{{ i }}">{{ limoAsDirectedDuration }} </span>
                        <span i18n="@@taxiSearchHours">hours</span>
                      </option>
                    }
                  </select>
                </div>
              }
            </div>
          </div>
        }
      } @else if (!showDateBlock && !isVia) {
        <mat-checkbox
          class="light-primary stop-check-box"
          color="primary"
          #addStopCheckbox
          id="taxi-add-stop"
          [checked]="isStopChecked"
          (change)="onAddStopChange(addStopCheckbox.checked)"
          (keydown.enter)="onAddStopChange(addStopCheckbox.checked)"
          i18n="@@taxiSearchAddStop"
        >
          Add a stop
        </mat-checkbox>
      }
    </div>
    @if (mode === TaxiFormMode.ADDRESS) {
      @if (type === LocationTypes.Airport || address?.Terminal) {
        <div class="flex-row-container">
          <div class="flight-info-container">
            <div class="flight-info-item">
              <label
                class="header-label"
                i18n="@@taxiAddressFlightNo"
                id="{{ transformedTitle }}-taxi-address-fligh-number"
                for="{{ title }}flightNo"
                >Flight Number</label
              >
              @if (searchParams.vehicleType === CabHireVehicleType.Limo) {
                <span>*</span>
              }
              <input
                type="text"
                [required]="searchParams.vehicleType === CabHireVehicleType.Limo"
                id="{{ title }}flightNo"
                [(ngModel)]="address.FlightNumber"
                (ngModelChange)="onChange($event)"
                attr.aria-labelledby="{{ transformedTitle }}-taxi-address-fligh-number"
                i18n-placeholder
                maxlength="10"
                placeholder="e.g. BA123"
                maxlength="10"
                appInput
                [noIcon]="true"
              />
            </div>
            @if (searchParams.vehicleType === CabHireVehicleType.Limo) {
              <div class="flight-info-item">
                <label
                  class="header-label"
                  id="{{ transformedTitle }}-taxi-flight-time"
                  for="{{ title }}flightTime"
                >
                  <span i18n="@@taxiFlight"> Flight </span>
                  @if (title.includes('Pick')) {
                    <span i18n="@@taxiFlightArrival"> Arrival </span>
                  }
                  @if (title.includes('Drop')) {
                    <span i18n="@@taxiFlightDeparture"> Departure </span>
                  }
                  <span i18n="@@taxiFlightTime"> Time* </span>
                </label>
                <div class="flex-row-container">
                  <i class="ico-clock combo-box-icon combo-box-icon--left" aria-hidden="true"></i>
                  <select
                    required
                    id="{{ title }}flightTime"
                    appSelect
                    [(ngModel)]="address.FlightTrainDateTime"
                    attr.aria-labelledby="{{ transformedTitle }}-taxi-flight-time"
                    tabindex="0"
                  >
                    @for (
                      time of getTimeArray(
                        searchParams.time,
                        title.includes('Drop'),
                        address.FlightTrainDateTime
                      );
                      track time
                    ) {
                      <option [ngValue]="time">
                        {{ time }}
                      </option>
                    }
                  </select>
                </div>
              </div>
            }
          </div>
          <div>
            <label
              class="header-label"
              i18n="@@taxiAddressChooseTerminal"
              for="{{ transformedTitle }}-terminal"
              >Terminal*</label
            >
            <select
              appInput
              [noIcon]="true"
              class="button-box"
              [ngModel]="
                address?.Terminal ||
                (showDateBlock
                  ? searchParams.fromTerminals[0]?.key
                  : isVia
                    ? searchParams.viaTerminals[0]?.key
                    : searchParams.toTerminals[0]?.key)
              "
              (ngModelChange)="addTerminal($event)"
              id="{{ transformedTitle }}-terminal"
              required
            >
              @for (
                terminal of showDateBlock
                  ? searchParams.fromTerminals
                  : isVia
                    ? searchParams.viaTerminals
                    : searchParams.toTerminals;
                track terminal
              ) {
                <option class="light-dropdown" [value]="terminal.key">
                  {{ terminal.key | translate }}
                </option>
              }
            </select>
          </div>
          @if (searchParams.vehicleType === CabHireVehicleType.Limo) {
            <div>
              <label
                class="header-label"
                i18n="@@taxiAddressAirline"
                id="{{ transformedTitle }}-taxi-address-airline"
                for="{{ title }}Airline"
                >Airline*</label
              >
              <input
                autocomplete="off"
                [ngClass]="{ invalidAirline: invalidAirlineSelected }"
                required
                name="flight_airlines"
                i18n-placeholder
                placeholder="Select airline"
                container="body"
                placement="bottom-left"
                type="text"
                appInput
                [noIcon]="true"
                [(ngModel)]="carrier"
                [ngbTypeahead]="getAirline"
                [resultTemplate]="airlinesTemplate"
                [inputFormatter]="formatter_airlines"
                (focus)="updateAirline($event)"
                (click)="updateAirline($event)"
                (ngModelChange)="onChange($event)"
                attr.aria-labelledby="{{ transformedTitle }}-taxi-address-airline"
                id="{{ title }}Airline"
                (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                (keyup.arrowup)="ensureElementIsScrolledTo($event)"
              />
              @if (invalidAirlineSelected) {
                <div class="error-message mt-2" i18n="@@taxiPleaseSelectAnAirline">
                  Please select an airline from the list.
                </div>
              }
            </div>
          }
        </div>
      }

      @if (
        type === LocationTypes.TrainStation && searchParams.vehicleType === CabHireVehicleType.Limo
      ) {
        <div flex-row-container>
          <h2 style="color: white" i18n="@@taxiAddressTrainDetails">Train Details</h2>
          <div class="train-details">
            <div class="train-operator-container">
              <label
                class="header-label"
                i18n="@@taxiATrainOperator"
                id="{{ transformedTitle }}-taxi-train-operator"
                for="{{ title }}trainOperator"
                >Train Operator*</label
              >
              <input
                attr.aria-labelledby="{{ transformedTitle }}-taxi-address-train-operator"
                appInput
                [noIcon]="true"
                required
                i18n-placeholder
                id="{{ transformedTitle }}-taxi-train-operator"
                placeholder="Select Train Operator"
                [(ngModel)]="carrier"
                (ngModelChange)="onChange($event)"
              />
            </div>
            <div class="train-time-container">
              <label
                class="header-label"
                id="{{ transformedTitle }}-taxi-address-train-time"
                for="{{ title }}TrainTime"
              >
                <span i18n="@@taxiTrain">Train</span>
                @switch (title) {
                  @case ('Pick up') {
                    <span i18n="@@taxiFlightArrival"> Arrival </span>
                  }
                  @case ('Pickup Via') {
                    <span i18n="@@taxiFlightArrival"> Arrival </span>
                  }
                  @case ('Drop off') {
                    <span i18n="@@taxiFlightDeparture"> Departure </span>
                  }
                  @case ('Dropoff Via') {
                    <span i18n="@@taxiFlightDeparture"> Departure </span>
                  }
                }
                <span i18n="@@taxiFlightTime"> Time* </span>
              </label>
              <div class="train-time-wrapper">
                <i class="ico-clock select-box-icon--left" aria-hidden="true"></i>
                <select
                  required
                  id="{{ title }}TrainTime"
                  appSelect
                  [(ngModel)]="address.FlightTrainDateTime"
                  attr.aria-labelledby="{{ transformedTitle }}-taxi-address-train-time"
                  tabindex="0"
                >
                  @for (
                    time of getTimeArray(
                      searchParams.time,
                      title.includes('Drop'),
                      address.FlightTrainDateTime
                    );
                    track time
                  ) {
                    <option [ngValue]="time">
                      {{ time }}
                    </option>
                  }
                </select>
              </div>
            </div>
          </div>
        </div>
      }
    } @else {
      <div class="remove-address-row">
        <button
          id="{{ transformedTitle }}-taxi-remove-address-button"
          (click)="openRemoveAddressesModal()"
          [disabled]="savingAddress"
          appButton="small"
          class="small-button--reduced-text small-button--flex margin-right-5"
        >
          @if (savingAddress) {
            <app-loading-spinner size="sm" />
          }
          @if (!savingAddress) {
            <span i18n="@@taxiAddressRemoveAddress">Remove Saved Addresses</span>
          }
          <span class="visuallyhidden">{{ title }}</span>
          <span class="visuallyhidden" i18n="@@taxiAddressForm">Form</span>
        </button>
      </div>
    }
  </fieldset>
</mat-expansion-panel>
